import React, { useEffect, useState } from 'react';
import { Table, Pagination, Header, Icon } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { observer } from 'mobx-react-lite';
import agent from '../../app/api/agent';
import { useStore } from '../../app/stores/store';
import LoadingComponent from '../../app/layout/LoadingComponent';

const ShotwiseQC = () => {
  const { reportStore } = useStore();
  const workLevelPage = 10;
  const itemsperPage = 5;
  const elementPerPage = 5;
  const headers = [
    'Work Level',
    '',
    'Total Number of Items',
    'Element Type Details',
    'Items picked',
    'Items borrowed',
  ];
  const [reportData, setReportData] = useState<any[]>([]);
  const [expandedRow, setExpandedRow] = useState<string>('');
  const [expandedItem, setExpandedItem] = useState<string>('');
  const [activeitempage, setactiveitempage] = useState<any>(1);
  const [activeElementPage, setactiveElementPage] = useState<any>(1);
  const [activePage, setActivePage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  const getPaginationCount = async () => {
    const paginationCount = await agent.WorkLevels.viewItemGroupsCountAPI({
      searchvalue: '',
    });
    setTotalPage(Math.ceil(paginationCount.data / workLevelPage));
  };

  const getData = async () => {
    // const tempGroupedData: any = [];
    // setGroupedData([]);
    // reportStore.assetTrackingReportData?.forEach(
    //   (item: { worklevel: string | number }) => {
    //     if (!tempGroupedData[item.worklevel]) {
    //       tempGroupedData[item.worklevel] = [];
    //     }
    //     tempGroupedData[item.worklevel]?.push(item);
    //   }
    // );
    // setGroupedData(Object.values(tempGroupedData));
    const data = await reportStore.reportDataInfo(1, workLevelPage);
    setReportData(data);
  };

  useEffect(() => {
    getPaginationCount();
    setTimeout(() => {
      getData();
    }, 300);
    // eslint-disable-next-line
  }, []);

  const toggleExpandRow = async (worklevel: string) => {
    setactiveitempage(1);
    if (expandedRow === worklevel) {
      setExpandedRow('');
      setExpandedItem('');
      // setUniqueItems([]);
    } else {
      setExpandedRow(worklevel);
      reportStore.AssetTrackingTableData(worklevel, 1, itemsperPage);
    }
  };

  // Toggle expand/collapse item row
  const toggleExpandItem = (itemId: string) => {
    setactiveElementPage(1);
    if (itemId === expandedItem) {
      setExpandedItem('');
    } else {
      setExpandedItem(itemId);
    }
  };

  const handlePageChange = async (_e: any, { activePage }: any) => {
    // setGroupedData([]);
    setExpandedRow('');
    setExpandedItem('');
    setActivePage(activePage);
    const data = await reportStore.reportDataInfo(activePage, workLevelPage);
    setReportData(data);
    // setTimeout(() => {
    //   getData();
    // }, 300);
  };

  const itemsPagination = (_e: any, page: any, workLevel: string) => {
    setactiveitempage(page);
    reportStore.AssetTrackingTableData(workLevel, page, itemsperPage);
  };

  return (
    <>
      <div className="asset-tracking-report">
        <Header>Asset Tracking Report</Header>
        {reportData?.length === 0 ? (
          <LoadingComponent />
        ) : (
          <Table>
            <Table.Header>
              <Table.Row>
                {headers?.map((header: string, index: number) => {
                  return (
                    <Table.HeaderCell key={index}>{header}</Table.HeaderCell>
                  );
                })}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {reportData?.map((Group, index) => (
                <React.Fragment key={index}>
                  <Table.Row onClick={() => toggleExpandRow(Group.title)}>
                    <Table.Cell rowSpan="2" width={2}>
                      {Group.title}
                    </Table.Cell>
                    <Table.Cell rowSpan="2">
                      <span>
                        {expandedRow === Group.title ? (
                          <Icon name="minus" color="grey" />
                        ) : (
                          <Icon name="plus" color="grey" />
                        )}
                      </span>
                    </Table.Cell>
                    <Table.Cell>{Group.total_No_Of_Items}</Table.Cell>
                    <Table.Cell>
                      {Group.element_Type_Details?.map(
                        (data: string, ind: number) => {
                          return (
                            <span key={ind}>
                              <span>{data}</span>
                              {Group.element_Type_Details?.length !==
                              ind + 1 ? (
                                <span>&nbsp;,&nbsp;</span>
                              ) : null}
                            </span>
                          );
                        },
                      )}
                    </Table.Cell>
                    <Table.Cell>{Group.item_Picked}</Table.Cell>
                    <Table.Cell>{Group.item_Borrowed}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    {expandedRow === Group.title ? (
                      <Table.Cell colSpan="4">
                        <Table>
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell width={4}>
                                Item Name
                              </Table.HeaderCell>
                              <Table.HeaderCell colSpan="2" width={12}>
                                Item Details
                              </Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>
                            {reportStore.assetTrackingReportData &&
                              reportStore.assetTrackingReportData.map(
                                (item: any, idx) => (
                                  <Table.Row
                                    key={idx}
                                    onClick={() =>
                                      toggleExpandItem(item.itemId)
                                    }
                                  >
                                    <Table.Cell>
                                      <div>{item.itemname}</div>
                                    </Table.Cell>
                                    <Table.Cell>
                                      <div>
                                        {expandedItem === item.itemId ? (
                                          <Icon name="minus" color="grey" />
                                        ) : (
                                          <Icon name="plus" color="grey" />
                                        )}
                                      </div>
                                    </Table.Cell>
                                    {expandedItem === item.itemId && (
                                      <Table>
                                        <Table.Header>
                                          <Table.Row>
                                            <Table.HeaderCell textAlign="left">
                                              Element type
                                            </Table.HeaderCell>
                                            <Table.HeaderCell textAlign="left">
                                              Order Tracking status
                                            </Table.HeaderCell>
                                            <Table.HeaderCell textAlign="left">
                                              Date of Delivery
                                            </Table.HeaderCell>
                                            <Table.HeaderCell textAlign="left">
                                              Date of Return
                                            </Table.HeaderCell>
                                            <Table.HeaderCell textAlign="left">
                                              Picker
                                            </Table.HeaderCell>
                                            <Table.HeaderCell textAlign="left">
                                              Borrower
                                            </Table.HeaderCell>
                                          </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                          {reportStore.assetTrackingReportData?.map(
                                            (data: any) => {
                                              return (
                                                !!(
                                                  expandedItem === data.itemId
                                                ) && (
                                                  <Table.Row key={index}>
                                                    <Table.Cell>
                                                      {data?.elementtype}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                      {
                                                        data?.orderTrackingstatus
                                                      }
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                      {data?.dateofDelivery}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                      {data?.dateofReturn}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                      {data?.picker}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                      {data?.borrower}
                                                    </Table.Cell>
                                                  </Table.Row>
                                                )
                                              );
                                            },
                                          )}
                                          <Table.Row>
                                            {Math.ceil(
                                              reportStore
                                                .assetTrackingReportData
                                                .length / elementPerPage,
                                            ) === 1 ? null : (
                                              <Table.Cell
                                                colSpan={6}
                                                textAlign="left"
                                              >
                                                <Pagination
                                                  activePage={activeElementPage}
                                                  totalPages={Math.ceil(
                                                    reportStore
                                                      .assetTrackingReportData
                                                      .length / elementPerPage,
                                                  )}
                                                  onPageChange={(e, data) =>
                                                    setactiveElementPage(
                                                      data.activePage,
                                                    )
                                                  }
                                                />
                                              </Table.Cell>
                                            )}
                                          </Table.Row>
                                        </Table.Body>
                                      </Table>
                                    )}
                                  </Table.Row>
                                ),
                              )}
                            <Table.Row>
                              <Table.Cell colSpan={6}>
                                {Math.ceil(
                                  Group.total_No_Of_Items / itemsperPage,
                                ) === 1 ? null : (
                                  <Pagination
                                    activePage={activeitempage}
                                    totalPages={Math.ceil(
                                      Group.total_No_Of_Items / itemsperPage,
                                    )}
                                    onPageChange={(_e, data) =>
                                      itemsPagination(
                                        _e,
                                        data.activePage,
                                        Group.title,
                                      )
                                    }
                                  />
                                )}
                              </Table.Cell>
                            </Table.Row>
                          </Table.Body>
                        </Table>
                      </Table.Cell>
                    ) : null}
                  </Table.Row>
                </React.Fragment>
              ))}
            </Table.Body>
          </Table>
        )}
        {totalPage === 1 ? null : (
          <Pagination
            activePage={activePage}
            totalPages={totalPage}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
};

export default observer(ShotwiseQC);
